export default "__VITE_ASSET__bc25eb77__"